import React from "react";
import clsx from "clsx";

import IconClock from "static/images/clock.png";
import { ReactComponent as IconAlert } from "static/images/alert-round.svg";
import { ReactComponent as AlertIcon } from "static/images/alert_4.svg";
import styles from "./statusTag.module.scss";

type StatusTagProps = {
	value: string;
	icon?: "alert" | "clock" | "circle-alert";
	variant?: "primary" | "warning";
	className?: string;
};

const IconComponents = {
	alert: <AlertIcon className={styles.iconAlert} />,
	clock: <img src={IconClock} alt="" />,
	"circle-alert": <IconAlert className={styles.iconCircleAlert} />,
};

const StatusTag = ({
	value,
	icon,
	variant = "primary",
	className,
}: StatusTagProps) => {
	return (
		<div
			className={clsx(styles.wrappStatusTab, styles[variant], className)}
		>
			{icon && (
				<span className={styles.icon}>{IconComponents[icon]}</span>
			)}
			<span>{value}</span>
		</div>
	);
};

export default StatusTag;
